<div class="w-full">
  <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
    <div class="flex items-center">
      <h6 mat-dialog-title class="font-semibold primary-font">{{this.data?.options?.titleDisplayKey ?
        (this.data?.options?.titleDisplayKey | translate) : this.data?.options?.titleDisplayName}}
        {{(productDetailsData?.product_name || productDetailsData?.name) ? '\'' + (productDetailsData?.product_name ||
        productDetailsData?.name) + '\'': ''}} {{data?.options?.type === 'view' ? ('details' | translate) : ''}}</h6>
    </div>
    <div class="flex items-center mr-1">
      <span mat-dialog-close class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </span>
    </div>
  </div>
  <div class="rounded-md bg-gray-50 px-4 py-3" *ngIf="this.data?.module === 'PROJECT' && data?.project?.project_name">
    <div class="flex">
        <div class="flex-shrink-0">
            <i class="ti ti-alert-circle text-gray-700 text-2xl"></i>
        </div>
        <div class="ml-3">
            <p class="text-base font-semibold text-gray-700 flex justify-between">
                {{"text.parts.linked.text" | translate}} "<strong>{{data?.project?.project_name}}</strong>"
            </p>
        </div>
    </div>
  </div>
  <div class="flex flex-col zuper-dialog-body max-dialog-height overflow-y-auto zuper-scrollbar">
    <div>
      <form [formGroup]="updatePartsOrServicesForm" class="cancelForm h-full grid grid-cols-2 gap-6 overflow-y-none" autocomplete="off">
        <ng-container *ngFor="let field of partsFormFields">
          <div *ngIf="field?.showField" [ngClass]="{'col-span-2' : ['product_description','description','serial_nos','is_billable'].includes(field?.fieldName)}">
            <div class="flex flex-col">
              <label class="primary-font mat-form-field font-semibold mb-2 text-base" [ngClass]="{'required': field?.isRequired}" *ngIf="!['product_description','description'].includes(field?.fieldName) && field?.showField">{{ field?.fieldLabel| translate}}</label>
              <div class="text-base break-words" *ngIf="field?.displayType === 'text' && !['product_description','description','location_uid','serial_nos','markup'].includes(field?.fieldName) && field?.showField">{{productDetailsData[field?.fieldName] ?? '---'}}</div>
              <div class="text-base break-words" *ngIf="field?.displayType === 'text' && ['markup'].includes(field?.fieldName) && field?.showField">{{productDetailsData[field?.fieldName]?.['markup_value'] ?? '---'}}</div>
              <div class="text-base break-words" *ngIf="field?.displayType === 'text' && ['location_uid'].includes(field?.fieldName) && field?.showField">{{locationName ?? '---'}}</div>
              <ng-container *ngIf="['brand','specification','id','name','product_id','product_name'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                <mat-form-field class="example-full-width" appearance="fill" ngClass="w-full" [floatLabel]="'always'" [hideRequiredMarker]="true" *ngIf="field?.displayType === 'input' && field?.showField">
                  <input type="text" matInput class="form-control" [formControlName]="field?.fieldName" placeholder="{{field?.placeholder | translate}}">
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="['price','unit_price','purchase_price','selling_price'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                <mat-form-field class="example-full-width" appearance="fill" ngClass="w-full" [floatLabel]="'always'" [hideRequiredMarker]="true" *ngIf="field?.displayType === 'input' && field?.showField">
                  <input type="number" [min]="!['price','selling_price'].includes(field?.fieldName) && 0" restrictNumberDecimal [step]="stepValue" [ngClass]="{'selling-price' :['price','selling_price'].includes(field?.fieldName)}" matInput class="form-control" [formControlName]="field?.fieldName" placeholder="{{field?.placeholder | translate}}">
                  <span matPrefix>{{companyCurrency}}</span>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="['quantity','planned_quantity'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                <mat-form-field class="example-full-width" appearance="fill" ngClass="w-full" [floatLabel]="'always'" [hideRequiredMarker]="true" *ngIf="field?.displayType === 'input' && field?.showField">
                  <input type="number" matInput class="form-control" [formControlName]="field?.fieldName" placeholder="{{field?.placeholder | translate}}">
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="['location_uid'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                <mat-form-field appearance="fill" class="w-full mt-1 mb-1">
                  <mat-select (selectionChange)="locationNameChange($event)" [formControlName]="field?.fieldName" placeholder="{{field?.placeholder | translate}}">
                    <mat-option value=""> {{'no.location.text' | translate}} </mat-option>
                    <mat-option [value]="option?.location?.location_uid"  *ngFor="let option of availableLocations"> {{option?.location?.location_name}} </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="['serial_nos'].includes(field?.fieldName)  && field?.showField">
                <div class="text-base break-words" *ngIf="field?.displayType === 'text'">{{productDetailsData[field?.fieldName]?.length > 0 ? productDetailsData[field?.fieldName] : '---'}}</div>
                <div *ngIf="field?.displayType === 'input'">
                  <ng-select
                          [items]="serialNumbers"
                          id="{{field?.fieldName}}"
                          class="form-control"
                          placeholder="{{field?.placeholder | translate}}"
                          appendTo="body"
                          [multiple]="true"
                          [hideSelected]="true"
                          [addTag]="field?.allowAddValue ?? false"
                          addTagText="add"
                          typeToSearchText="{{'info.type_to_search_text' | translate}}"
                          [formControlName]="field?.fieldName"
                          >
                  </ng-select>
                </div>
              </ng-container>
              <ng-container *ngIf="['discount'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                <mat-form-field class="example-full-width" appearance="fill" ngClass="w-full" [hideRequiredMarker]="true" [floatLabel]="'always'" *ngIf="field?.displayType === 'input' && field?.showField">
                  <input type="number" matInput class="form-control" [formControlName]="field?.fieldName" placeholder="{{field?.placeholder | translate}}">
                  <span matPrefix>
                    <mat-select formControlName="discount_type">
                      <mat-option [value]="option.value" *ngFor="let option of discountType"> {{option.key}} </mat-option>
                    </mat-select>
                  </span>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="(field?.fieldName === 'tax_preference') && (field?.displayType === 'input') && field?.showField">
                  <mat-form-field appearance="fill" class="w-full mt-1 mb-1">
                    <mat-select  [formControlName]="field.fieldName">
                        <mat-option [value]="true"> {{ "text.non_taxable" | translate}} </mat-option>
                        <mat-option [value]="false"> {{ "taxable.text" | translate}} </mat-option>
                    </mat-select>
                  </mat-form-field>
              </ng-container>
              <ng-container *ngIf="['tax_code'].includes(field?.fieldName) && field?.displayType === 'input' && field?.showField">
                <app-tax-code (codeSelected)="changeTaxCode($event)" [value]="taxCode"></app-tax-code>
              </ng-container>
              <ng-container *ngIf="(field?.fieldName === 'markup') && (field?.displayType === 'input') && field?.showField">
                <div class="flex">
                  <input 
                      type="number"
                      [min]="0"
                      [step]="stepValue"
                      restrictNumberDecimal
                      [formControlName]="field.fieldName"
                      (change)="markupValueChange($event)"
                      placeholder="{{field?.placeholder | translate}}"
                      class="block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                  > 
                  <span [matMenuTriggerFor]="dropdown"
                         class="inline-flex items-center px-3 text-md text-gray-900 border border-l-0 border-gray-300 rounded-r-md"
                         [ngClass]="{'pointer-events-none':updatePartsOrServicesForm.controls?.markup?.disabled, 'cursor-pointer': updatePartsOrServicesForm.controls?.markup?.enabled }"
                         >
                    <span class="text-lg" *ngIf="markupType === 'FLAT'">
                      <i class="ti ti-plus"></i>
                    </span>
                    <span  class="text-lg" *ngIf="markupType === 'PERCENTAGE'">
                      <i class="ti ti-percentage"></i>
                    </span>
                    <span  class="text-lg" *ngIf="markupType === 'MULTIPLIER'">
                      <i class="ti ti-x"></i>
                    </span>
                    <em class="text-xl" class="ti ti-chevron-down text-base font-semibold ml-2"></em>
                  <mat-menu #dropdown="matMenu" class="markup-menu">
                      <div (click)="changeMarkupType('FLAT')">
                          <a mat-menu-item class="h-10">
                              <span class="ml-2 text-base space-x-2"> 
                                <i class="ti ti-plus"></i> <span>{{'text.flat' | translate}}</span> 
                              </span>
                          </a>
                      </div>
                      <div (click)="changeMarkupType('PERCENTAGE')">
                          <a mat-menu-item class="h-10">
                              <span class="ml-2 text-base space-x-2">
                                <i class="ti ti-percentage"></i><span>{{'text.percentage' | translate}}</span>
                              </span>
                          </a>
                      </div>
                      <div (click)="changeMarkupType('MULTIPLIER')">
                          <a mat-menu-item class="h-10">
                              <span class="ml-2 text-base space-x-2">
                                <i class="ti ti-x"></i><span>{{'text.multiplier' | translate}}</span>
                              </span>
                          </a>
                      </div>
                  </mat-menu>
                  </span>
              </div>
            </ng-container>
              <div  class="flex flex-col w-full" *ngIf="['product_description','description'].includes(field?.fieldName) && field?.showField">
                <mat-label class="primary-font mat-form-field font-semibold mb-2 text-base" [ngClass]="{'required': field?.isRequired}">{{ field?.fieldLabel| translate}}</mat-label>
                <ng-container *ngIf="field?.displayType === 'text'">
                  <div class="text-base break-words" *ngIf="!utilityService.isEmptyOrUndefined(productDetailsData[field?.fieldName])"
                    [innerHTML]="productDetailsData[field?.fieldName] | safeHtml: false"></div>
                  <span *ngIf="utilityService.isEmptyOrUndefined(productDetailsData[field?.fieldName])">---</span>
                </ng-container>
                      <div class="mt-1 h-60" *ngIf="showEditor && field?.displayType === 'input'">
                        <text-editor
                        [editorData]="updatePartsOrServicesForm.controls[field?.fieldName]"
                        [options]="textEditorOptions"
                        style="font-size: 14px;"
                        ></text-editor>
                    </div>
              </div>
              <ng-container *ngIf="['is_billable'].includes(field?.fieldName) && field?.showField">
                <div class="flex justify-between items-center w-full border-t border-gray-300">
                  <div class="flex flex-col w-full">
                    <p class="text-base primary-font pt-2 font-medium">{{'text.is.item.billable' | translate}} ?</p>
                    <p class="text-base primary-font text-secondary">{{'text.isbillable.subtext' | translate}}</p>
                  </div>
                  <div class="flex items-center w-full custom-slide-toggle">
                    <mat-slide-toggle #billable [disableRipple]="true" [color]="'#1A237E'"
                                [formControlName]="field?.fieldName"></mat-slide-toggle>
                  </div>
                </div>
              </ng-container>
              <mat-error *ngIf="updatePartsOrServicesForm?.controls[field?.fieldName]?.touched && updatePartsOrServicesForm?.controls[field?.fieldName]?.invalid && (updatePartsOrServicesForm?.controls[field?.fieldName]?.hasError('required') || updatePartsOrServicesForm?.controls[field?.fieldName]?.hasError('validMinValue'))" class="primary-font font-semibold mt-1 text-base">
                {{getRequiredErrorMessage(field?.fieldName)}}
              </mat-error>
              <mat-error *ngIf="updatePartsOrServicesForm?.controls[field?.fieldName]?.touched && updatePartsOrServicesForm?.controls[field?.fieldName]?.invalid && updatePartsOrServicesForm?.controls[field?.fieldName]?.hasError('max')" class="primary-font font-semibold mt-1 text-base">
                {{'field.max.error.message' | translate}} 
              </mat-error>
              <mat-error *ngIf="updatePartsOrServicesForm?.controls[field?.fieldName]?.touched && updatePartsOrServicesForm?.controls[field?.fieldName]?.invalid && updatePartsOrServicesForm?.controls[field?.fieldName]?.hasError('invalidSerialNo')" class="primary-font font-semibold mt-1 text-base">
                {{'lineitem.picker.serialCount_quantity.error' | translate}}
              </mat-error>
            </div>
          </div>
        </ng-container>
        <div class="grid grid-cols-2" *ngIf="showRecurrence">
          <div class="w-full flex col-span-2 items-center space-x-2">
            <input
                type="checkbox"
                id="update" formControlName="update_all_jobs"/>
                <span>{{'delete.line.item.recuurent.job.message' | translate}}</span>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
    <div class="flex justify-around space-x-4">
        <button type="button" mat-stroked-button mat-dialog-close class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{this.data?.options?.submitDisplayKey ? ('cancel.text' | translate) : ('close.text' | translate)}}</button>
        <button *ngIf="(this.data?.options?.submitDisplayKey || this.data?.options?.submitDisplayName)" (click)="updatePartsOrServices()" class="min-w-24 px-6 btn-small items-center py-2 border b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary">
          <span>{{this.data?.options?.submitDisplayKey ? (this.data?.options?.submitDisplayKey | translate) : this.data?.options?.submitDisplayName}}</span>
        </button>
    </div>
  </div>
</div> 